import { styled } from 'styled-components'
import { theme } from './theme'

export const Styled_Button_Main = styled.button<{ $bgColor?: string; $width?: string; $height?:string; }>`
  background-color: ${({ $bgColor }) => ($bgColor ? $bgColor : theme.colors.green)};
  color: ${theme.colors.white};
  width: ${({ $width }) => ($width ? $width : '')};
  height: ${({ $height }) => ($height ? $height : '41px')};
  border: none;
  padding: 0px 15px;
  font-size: 1rem;
  border-radius: 10px;
  cursor: pointer;
  opacity: 1;
  transition:
    opacity 0.2s ease,
    transform 0.2s ease; /* 색상과 크기 전환 효과 */

  &:hover {
    opacity: 0.8;
    color: ${theme.colors.white};
    transform: scale(1.05);
  }
  &.loading {
    opacity: 0.3;
    pointer-events: none;
  }
`

export const Styled_Button_Delete = styled.button<{ $bgColor?: string; $width?: string; $height?:string; }>`
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${({ $bgColor }) => ($bgColor ? $bgColor : theme.colors.red)};
  color: ${theme.colors.white};
  width: ${({ $width }) => ($width ? $width : '18px')}; /* 버튼 크기 */
  height: ${({ $height }) => ($height ? $height : '18px')}; /* 버튼 높이 */
  border-radius: 50%; /* 원형 버튼 */
  cursor: pointer;
  opacity: 1;
  transition:
    opacity 0.2s ease,
    transform 0.2s ease; /* 색상과 크기 전환 효과 */

  /* 흰색 가로 막대 추가 */
  position: relative;

  &:before {
    content: '';
    position: absolute;
    width: 60%; /* 가로 막대 너비 */
    height: 10%; /* 가로 막대 높이 */
    background-color: ${theme.colors.white}; /* 막대 색상 */
    border-radius: 5px; /* 막대 모서리 둥글게 */
  }

  &:hover {
    opacity: 0.8;
    transform: scale(1.05);
  }

  &.loading {
    opacity: 0.3;
    pointer-events: none;
  }
`;